import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { YambaRootState } from '../store';

export type QuestionHighlightsState = string[]

const initialState: QuestionHighlightsState = [];

const questionHighlightsSlice = createSlice({
  name: 'questionHighlights',
  initialState,
  reducers: {
    setQuestionHighlights(state, action: PayloadAction<{ timestamps: string[] }>) {
      return action.payload.timestamps;
    },
    toggleQuestionHighlight(state, action: PayloadAction<{ timestamp: string }>) {
      const { timestamp } = action.payload;
      if (state.find((t) => t === timestamp)) {
        return state.filter((t) => t !== timestamp);
      }
      return state.concat([timestamp]);
    }
  }
});

export const getCountSelector = (state: YambaRootState) => state.questionHighlights.length;

export const getAddedSelector = (timestamp: string) => (state: YambaRootState) => state.
  questionHighlights.includes(timestamp);

export const {
  setQuestionHighlights,
  toggleQuestionHighlight
} = questionHighlightsSlice.actions;
export default questionHighlightsSlice.reducer;
